// Mock data — keep separate for easy backend swap later

import ritikaPhoto from './assets/ritika.jpeg';
import personalisationCover from './assets/personalisation.png';
import cocoCover from './assets/coco.png';
import wavesCover from './assets/shots-cover.png';
import specialsCover from './assets/specials.png';
import lifeMe from './assets/life/me.jpg';
import lifeTotoro from './assets/life/totoro.jpg';
import lifeGallery from './assets/life/gallery.jpg';
import lifeIced from './assets/life/iced.jpg';
import lifeJbp from './assets/life/jbp.jpg';

export const photo = ritikaPhoto;

export const identity = {
  firstName: 'RITIKA',
  lastName: 'GHOSH',
  title: 'Assistant Manager - UI/UX',
  company: 'Tata Play',
  location: 'Mumbai',
  email: 'ritikariya0609@gmail.com',
  linkedin: 'https://linkedin.com/in/ritikaghosh0609',
  resume: 'https://drive.google.com/file/d/1DDMILnJY00wFIlCId3LtJostvru8bCdk/view?usp=sharing',
  statusOpen: true,
};

export const bio = [
  "Hey there! I'm a Product Designer who gets genuinely excited by the problem before the solution — not the first obvious answer, but the one that's visually sharp, interaction-tight, and doesn't create friction in the same breath it tries to solve it.",
  "My strongest suit is bringing ideas to life through prototyping and motion. If I can make it feel right in Figma before a single line of code is written, the whole team moves faster and smarter.",
  "When I'm not designing, I'm painting on canvas, gallery-hopping, chasing golden hours, or deep in a new series — all of which, honestly, end up influencing how I design anyway.",
];

export const skills = [
  'Product Thinking',
  'Figma & Prototyping',
  'Motion Design',
  'Information Architecture',
  'Design Systems',
  'User Research',
  'Usability Testing',
  'Interaction Design',
];

export const experience = [
  {
    company: 'TATA PLAY',
    role: 'Assistant Manager - UI/UX',
    product: 'Tata Play Mobile App and Website',
    period: '2024 — Present',
  },
  {
    company: 'RELIANCE JIO',
    role: 'UI/UX Designer',
    product: 'MyJio App',
    period: '2021 — 2024',
  },
];

export const projects = [
  {
    slug: 'personalisation-myjio',
    title: 'Personalisation in MyJio',
    tags: ['UX Design', 'Personalisation'],
    company: 'Reliance Jio',
    year: '2022–23',
    description: 'Designing a personalised experience for 400M+ users',
    role: 'UI/UX Designer',
    platform: 'Android · iOS',
    focus: 'Personalisation · Recommendations',
    gradient: 'linear-gradient(135deg, #6B2737 0%, #8C3A4B 45%, #C4622D 100%)',
    cover: personalisationCover,
    full: true,
  },
  {
    slug: 'coco-integration-tataplay',
    title: 'Coco Integration',
    tags: ['Product Design', 'Integration'],
    company: 'Tata Play',
    year: '2025',
    description: 'Seamless integration into the Tata Play ecosystem',
    role: 'Assistant Manager - UI/UX',
    platform: 'Android TV · Mobile',
    focus: 'Integration · System design',
    gradient: 'linear-gradient(135deg, #1E2A4A 0%, #2E3A6B 50%, #4A3C6B 100%)',
    cover: cocoCover,
    full: false,
  },
  {
    slug: 'shots-tataplay',
    title: 'Shots on Tata Play',
    tags: ['Product Design', 'Microdrama'],
    company: 'Tata Play',
    year: '2025',
    description: 'A new habit, inside an old one — microdrama discovery & continuity',
    role: 'Assistant Manager - UI/UX',
    platform: 'End-to-end',
    focus: 'Discovery · Merchandising · Player · Engagement',
    gradient: 'linear-gradient(135deg, #4A2545 0%, #8C3A4B 55%, #C4622D 100%)',
    cover: wavesCover,
    full: false,
  },
  {
    slug: 'specials-destination-page',
    title: 'Specials Destination Page',
    tags: ['Content Design', 'Destination'],
    company: 'Tata Play',
    year: '2025',
    description: 'Curated destination for special content',
    role: 'Assistant Manager - UI/UX',
    platform: 'Android TV · Web',
    focus: 'Content design · Discovery',
    gradient: 'linear-gradient(135deg, #D4A853 0%, #A4501F 55%, #5C2E14 100%)',
    cover: specialsCover,
    full: true,
  },
];

export const lifeCards = [
  { image: lifeMe,      caption: 'me, off the clock',                              objectPosition: '50% 18%', gradient: 'linear-gradient(135deg, #C4622D 0%, #D4A853 100%)' },
  { image: lifeTotoro,  caption: 'Totoro and a window seat — both essential',      gradient: 'linear-gradient(135deg, #7A8C6E 0%, #C4622D 100%)' },
  { image: lifeGallery, caption: 'galleries on weekends, wireframes on Monday',    gradient: 'linear-gradient(135deg, #8C3A4B 0%, #D4A853 100%)' },
  { image: lifeIced,    caption: 'iced coffee is a personality trait',             gradient: 'linear-gradient(135deg, #5C4A38 0%, #A4501F 100%)' },
  { image: lifeJbp,     caption: 'home',                                            gradient: 'linear-gradient(135deg, #7A8C6E 0%, #5C4A38 100%)' },
];

export const testimonials = [
  {
    quote: "I had the pleasure of working with Ritika on multiple design projects for MyJio, where her creativity and attention to detail played a key role in shaping a seamless payments experience. Her ability to combine user-centric thinking with innovative design solutions made a significant impact on our product. A truly talented designer and a great team player!",
    name: 'Mudassir Faizan',
    role: 'UI/UX Designer · MyJio',
  },
  {
    quote: "Working with Ritika has been a delight. Her designs strike the right balance between user needs and business goals, delivered with speed and precision.",
    name: 'Prakhar Tiwari',
    role: 'Product Manager · Reliance Jio',
  },
];
